import { H5 } from 'UIComponents/elements/headings';
import { useShortFromPropsOrParams } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UITag from 'UIComponents/tag/UITag';
import { ExternalLearningContentBanner } from '../../learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortContentDetails = props => {
  const {
    short
  } = useShortFromPropsOrParams(props);
  if (!short) return null;
  const {
    description,
    subCategories,
    hubId
  } = short;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ExternalLearningContentBanner, {
      className: "m-bottom-8",
      hubId: hubId
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.descriptionHeader"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), /*#__PURE__*/_jsx(UIList, {
      childClassName: "m-right-4 m-bottom-2 p-x-0 p-y-0",
      inline: true,
      children: subCategories.map(subCategory => /*#__PURE__*/_jsx(UITag, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyCategories.${subCategory}`
        })
      }, subCategory))
    })]
  });
};
export default ShortContentDetails;